import { CHANNEL_CONFIGS } from "@/config/channel-configs";
import store from "@/store";
import { ChannelName, TFormatText } from "@/ts/common-types";
import { moduleConfigs } from "@ts/constants";
import { ValueFormatterParams } from "ag-grid-community";

const FilterTextFormatter = (params: ValueFormatterParams) => {
    const channel = store.getState().channel.value;
    const channelName = CHANNEL_CONFIGS[channel]?.name?.toLowerCase() as ChannelName | undefined;
    const channelOptions = moduleConfigs[channelName as ChannelName].options;
    return (
        channelOptions.formatText[params.colDef.field as keyof TFormatText][
            params.value
        ] || ""
    );
};

export default FilterTextFormatter;
